/* ============================================================
   DEOSA STUDIO — Shared scroll-reveal observer
   Loaded once. Watches all .deosa-reveal elements across sections.
   ============================================================ */
(function () {
  if (window.deosaRevealInit) return;
  window.deosaRevealInit = true;

  function init() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.deosa-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
